import React from "react";
import Meta from "../Components/Meta";
import CallToAction from "../Components/CallToAction";


const AboutPage = () => {
  return (
    <main className="max-w-4xl mx-auto px-4 py-16 space-y-12 text-white">
      <Meta title="会社情報|CAMARAGO" description="camaragoの会社情報ページです。" />
      <section>
        <h1 className="text-3xl font-bold text-white mb-4">当社について</h1>
        <p className="leading-relaxed">
          CAMARAGO（カマラゴ）は、スペイン語の “Cámara（カメラ）” と英語の
          “Go（気軽さを想起するワード）”
          を組み合わせたサービス名です。私たちが持つ全国レベルの設置作業員ネットワークと、簡単で直感的に最適な防犯カメラ選びできるサービスを実現。「すぐに使えて、どこでも設置できる、暮らしやビジネスにフィットする防犯カメラの設置を行います。面倒な選定や設置は一切不要。あなたにぴったりの防犯カメラを、スピーディーに、そして信頼できる形でご提供します。
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-white mb-2">企業理念</h2>
        <p>
          私たちは「テクノロジーで安心を可視化する」ことを使命とし、誰もが安全に暮らせる社会の実現を目指します。
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-white mb-2">主なサービス</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>防犯・監視カメラの提案と導入支援</li>
          <li>設置工事・保守メンテナンス</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-white mb-2">会社概要</h2>
        <table className="text-sm">
          <tbody>
            <tr>
              <td className="font-medium pr-4 py-1">会社名</td>
              <td>株式会社 GLANMA</td>
            </tr>
            <tr>
              <td className="font-medium pr-4 py-1">所在地</td>
              <td>〒612-0041 京都市伏見区深草北鍵屋町995-1</td>
            </tr>
            <tr>
              <td className="font-medium pr-4 py-1">設立</td>
              <td>2024年2月</td>
            </tr>
            <tr>
              <td className="font-medium pr-4 py-1">代表者</td>
              <td>代表取締役 城 翔貴</td>
            </tr>
            <tr>
              <td className="font-medium pr-4 py-1">電話番号</td>
              <td>09020422346</td>
            </tr>
          </tbody>
        </table>
      </section>

      <CallToAction />
    </main>
  );
};

export default AboutPage;
